// 权限管理
import http from '@/jslibs/axios/http';

// 登录
export const login = data => http.post('/cms/admin/login', data);

// 获取当前用户菜单列表
export const menus = () => http.get('/cms/menu/current');

